/*
 * Inits the builder showcase about page
 */
define(
  'testimonialsInitializer',[
    'favoritesLoader',
    'askQuestionLoader',
  ],
  () => {
    'use strict';
  }
);

